const route = [
  {
    path: '/estados-pago',
    name: 'estadosPago',
    meta: { authRequired: true },
    component: () => import('./EstadosPago.vue')
  },
];

module.exports = {
  route
};
